module.exports = __webpack_public_path__ + "img/iconOfflineBike.e71ba800.png";